export default __webpack_public_path__ + "static/media/TESTIMONI-ERNI MARLINA DEWI.bf9416dd.jpg";